module.exports = __webpack_public_path__ + "static_portal/img/shooting_the_slide_with_arrow_2.62c9209e.jpg";